export const toCapitalize = (str: string, allWords: boolean): string => {
  return str
    .split(' ')
    .map((word: string, index: number): string => {
      if (allWords || index > 0) {
        return (
          word.substr(0, 1).toUpperCase() +
          (word.length > 0 ? word.substr(1).toLowerCase() : '')
        );
      }
      return word.toLowerCase();
    })
    .join(' ');
};

export const capitalize = (text: string) => {
  if (typeof text !== 'string') {
    throw new Error('Error: capitalize(text) expects a string argument.');
  }

  return text.charAt(0).toUpperCase() + text.slice(1);
};

export const isFloat = (number: string) => /^[+-]?\d+(\.\d+)?$/.test(number);

export const toFixedPercentage = (perc: number): number => {
  if (perc <= 0) {
    return 0;
  }
  if (perc >= 100) {
    return 100;
  }
  const fixed = perc.toFixed(2).replace('.00', '');
  return isFloat(fixed) ? parseFloat(fixed) : parseInt(fixed);
};

export const getStringWithoutSpecialChar = (input: any) => {
  const value = String(input)
    .replace(/ã/g, 'a')
    .replace(/Ã/g, 'A')
    .replace(/á/g, 'a')
    .replace(/Á/g, 'A')
    .replace(/à/g, 'a')
    .replace(/À/g, 'A')
    .replace(/â/g, 'a')
    .replace(/Â/g, 'A')
    .replace(/é/g, 'e')
    .replace(/ê/g, 'e')
    .replace(/Ê/g, 'e')
    .replace(/É/g, 'E')
    .replace(/è/g, 'e')
    .replace(/È/g, 'E')
    .replace(/ì/g, 'i')
    .replace(/Ì/g, 'I')
    .replace(/í/g, 'i')
    .replace(/Í/g, 'I')
    .replace(/ó/g, 'o')
    .replace(/Ó/g, 'o')
    .replace(/ò/g, 'o')
    .replace(/Ò/g, 'o')
    .replace(/ô/g, 'o')
    .replace(/Ô/g, 'O')
    .replace(/õ/g, 'o')
    .replace(/Õ/g, 'O')
    .replace(/ç/g, 'c')
    .replace(/Ç/g, 'C');
  return value;
};

export function TextRange(text: string, limit = 500) {
  if (text.length > limit) {
    return text.slice(0, limit);
  }
  return text;
}

export function onlyNumbers(input: string | number): string {
  return String(input).replace(/[^\d]/g, '');
}

export function isLastChar(index: number, input: string): boolean {
  return index === input.length - 1;
}

export const LENGTH = 8;
export const HYPHEN_INDEXES = [4];
export function formatCEP(cep: string): string {
  const digits = onlyNumbers(cep);

  return digits
    .slice(0, LENGTH)
    .split('')
    .reduce((acc, digit, i) => {
      const result = `${acc}${digit}`;

      if (!isLastChar(i, digits)) {
        if (HYPHEN_INDEXES.indexOf(i) >= 0) return `${result}-`;
      }

      return result;
    }, '');
}
